<template>
  <v-form @submit.prevent="search">
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="10" class="my-0 py-0">
          <v-text-field
            @keyup.enter="search"
            v-model="nick"
            dense
            light
            color="grey darken-4"
            placeholder="Nickname a analizar"
            maxlength="31"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="2" class="my-0 py-0">
          <v-btn @click.stop="search" block depressed color="black" dark>Analizar</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
export default {
  name: "Buscar",

  data: () => ({
    nick: null
  }),

  methods: {
    search() {
      const name = this.nick;
      this.$emit("analizar", name);
    }
  }
};
</script>